export const getQueryInitialState = () => ({
    q: '',
    enableQuerySyntax: false,
});
